import { render } from "./ClientCargaMasivaProveedores.vue?vue&type=template&id=15ec6b3a&scoped=true"
import script from "./ClientCargaMasivaProveedores.vue?vue&type=script&lang=js"
export * from "./ClientCargaMasivaProveedores.vue?vue&type=script&lang=js"

import "./ClientCargaMasivaProveedores.vue?vue&type=style&index=0&id=15ec6b3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ec6b3a"]])

export default __exports__